module.exports = __webpack_public_path__ + "static/media/m120-42.fc10ee41.png";